/* eslint-disable react/jsx-no-comment-textnodes */
import React from "react";
import { Link } from "react-router-dom";

// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  const year = new Date().getFullYear();
  return (
    <footer className="pt-5 pb-3 dark_background">
      <div className="container-xxl">
        <div className="row gy-4 justify-content-between">
          <div className="col-md-6">
            <div className="d-flex flex-column gap-2">
              <h5>Blog</h5>
              <ul className="d-flex flex-column gap-0">
                <li>
                  <Link to="/introduction">Ai2dev introduction</Link>
                </li>
                <li>
                  <Link to="/how-kubernetes-powers-cloud-clusters">
                    How Kubernetes Powers Cloud Clusters
                  </Link>
                </li>
                <li>
                  <Link to="/kubernetes-on-vps">Kubernetes on VPS</Link>
                </li>
                <li>
                  <Link to="/cloud-backbone">
                    The Cloud Backbone- Powering AI Innovation and Scalable
                    Clusters
                  </Link>
                </li>
                <li>
                  <Link to="/understanding-cloud">
                    Understanding the Cloud
                  </Link>
                </li>
                <li>
                  <Link to="/aws-eks">Why We Choose AWS EKS </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3">
            <div className="d-flex flex-column gap-2">
              <h5>Products</h5>
              <ul className="d-flex flex-column gap-0">
                <li>
                  <Link to="/vps">Kubernetes on VPS</Link>
                </li>
                <li>
                  <Link to="/aws">Kubernetes on AWS</Link>
                </li>
                <li>
                  <Link to="/azure">Kubernetes on Azure</Link>
                </li>
                <li>
                  <Link to="/gcp">Kubernetes on GCP</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-3">
            <div className="d-flex flex-column gap-2">
              <h5>Usefull links</h5>
              <ul className="d-flex flex-column gap-0">

                <li>
                  <Link to="/blogs">Blog</Link>
                </li>
                <li>
                  <Link to="/about-us">About</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>

                <li>
                  <Link to="/onboarding">Onboarding</Link>
                </li>


              </ul>
            </div>
          </div>

          <div className="col-12 pt-3">
            <div className="d-flex flex-md-row flex-column gy-4 footer_bot align-items-md-center justify-content-md-between gap-3">
              <Link
                to="index"
                className="d-flex align-items-center gap-0 nav-log"
              >
                <div className="footer_logo">
                  <img
                    className="w-100 h-100 object-fit-cover"
                    src={require("../assets/images/logo.png")}
                    alt="AI2DEV logo"
                  />
                </div>
                <h2>AI2DEV </h2>
              </Link>
              <p>© AI2DEV {year}. All rights reserved.</p>
              <div className="d-flex align-items-center gap-3">
                <Link to="/">
                  <i className="fa-brands fa-instagram"></i>
                </Link>
                <Link to="/">
                  <i className="fa-brands fa-x-twitter"></i>
                </Link>
                <Link to="/">
                  <i className="fa-brands fa-square-facebook"></i>
                </Link>
                <Link to="/">
                  <i className="fa-brands fa-linkedin"></i>
                </Link>
                <Link to="/">
                  <i className="fa-brands fa-youtube"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

  );
}
